import React from 'react';
import { BlockRenderer } from '../renderer';
import { getNumberedListIndex } from '../utils/indentUtils';
import { htmlToText } from '../utils/caretUtils';

/**
 * ChoicePathBlock — one option inside a Choice. Layout-only (no drag handle);
 * the parent Choice owns the tab chrome. Labels show in All view and print.
 */
export const ChoicePathBlock = ({
  block,
  color,
  showLabel = false,
  visible = true,
  ...passThrough
}) => (
  <div
    className={`choice-path${visible ? ' choice-path--active' : ''}${showLabel ? ' choice-path--labeled' : ''}`}
    style={color ? { '--choice-tab-color': color } : undefined}
  >
    <div className="choice-path-label">{htmlToText(block.content || '') || 'Option'}</div>
    {block.children?.map((child, i) => (
      <BlockRenderer
        key={child.id}
        {...passThrough}
        block={child}
        prevType={block.children[i - 1]?.type}
        nextType={block.children[i + 1]?.type}
        listNumber={
          child.type === 'number' ? getNumberedListIndex(block.children, i) : undefined
        }
      />
    ))}
  </div>
);
